module.exports = __webpack_public_path__ + "img/1204629419.0557454a.jpg";